import React from 'react';
import {
    Container,
    Typography,
    Paper,
    Box,
    Link,
} from '@mui/material';

const Section = ({ title, children }) => (
    <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom color="primary">
            {title}
        </Typography>
        {children}
    </Box>
);

const Impressum = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Paper elevation={1} sx={{ p: 4 }}>
                <Typography variant="h4" gutterBottom align="center">
                    Impressum und Datenschutzerklärung
                </Typography>

                <Typography paragraph sx={{ mb: 4 }}>
                    Diese Webseite ist eine gemeinsame Initiative der Präsidentinnen und Präsidenten der Landessozialgerichte der Bundesländer.
                </Typography>

                <Section title="Herausgeber">
                    <Typography component="div">
                        Die Präsidentin des<br />
                        Bayerischen Landessozialgerichts<br />
                        Ludwigstraße 15, 80539 München<br />
                        Telefon: (089) 2367 - 1<br />
                        Telefax: (089) 2367 - 290<br />
                        Email: <Link href="mailto:poststelle@lsg.bayern.de">poststelle@lsg.bayern.de</Link>
                    </Typography>
                </Section>

                <Section title="Verantwortlich für den Inhalt">
                    <Typography paragraph>
                        Für die Bereitstellung der Daten und Informationen sind die jeweiligen Gerichte selbst verantwortlich. 
                        Bei Fragen und Problemen zu Inhalten auf diesen Seiten wenden Sie sich deshalb bitte unmittelbar an das Gericht, 
                        welches die Informationen abgestellt hat.
                    </Typography>
                </Section>

                <Section title="Webmaster">
                    <Typography>
                        Email: <Link href="mailto:webmaster-sgb@lsg.bayern.de">webmaster-sgb@lsg.bayern.de</Link>
                    </Typography>
                </Section>

                <Section title="Nutzungsbedingungen">
                    <Typography paragraph>
                        Texte, Bilder, Grafiken sowie die Gestaltung dieser Internetseiten können dem Urheberrecht unterliegen. 
                        Sie dürfen von Ihnen nur zum privaten und sonstigen eigenen Gebrauch im Rahmen des § 53 Urheberrechtsgesetz (UrhG) verwendet werden.
                    </Typography>
                    <Typography paragraph>
                        Nicht urheberrechtlich geschützt sind nach § 5 des Urheberrechtsgesetz (UrhG):
                    </Typography>
                    <Typography paragraph component="div" sx={{ pl: 2 }}>
                        • Gesetze, Verordnungen, amtliche Erlasse und Bekanntmachungen sowie Entscheidungen und amtlich verfasste Leitsätze zu Entscheidungen und<br />
                        • andere amtliche Werke, die im amtlichen Interesse zur allgemeinen Kenntnisnahme veröffentlicht worden sind, mit der Einschränkung, dass die Bestimmungen über Änderungsverbot und Quellenangabe in § 62 Abs. 1 bis 3 und § 63 Abs. 1 und 2 UrhG entsprechend anzuwenden sind.
                    </Typography>
                    <Typography paragraph>
                        Als Privatperson dürfen Sie urheberrechtlich geschütztes Material zum privaten und sonstigen eigenen Gebrauch 
                        im Rahmen des § 53 UrhG verwenden. Eine Vervielfältigung oder Verwendung dieser Seiten oder Teilen davon in 
                        anderen elektronischen oder gedruckten Publikationen und deren Veröffentlichung ist nur mit unserer Einwilligung 
                        gestattet. Diese erteilen auf Anfrage die für den Inhalt Verantwortlichen. Weiterhin können Texte, Bilder, 
                        Grafiken und sonstige Dateien ganz oder teilweise dem Urheberrecht Dritter unterliegen. Auch über das Bestehen 
                        möglicher Rechte Dritter geben Ihnen die für den Inhalt Verantwortlichen nähere Auskünfte.
                    </Typography>
                    <Typography paragraph sx={{ mb: 3 }}>
                        Der Nachdruck und die Auswertung von Urteilen, Beschlüssen und sonstigen Mitteilungen sind mit Quellenangabe allgemein gestattet.
                    </Typography>
                </Section>

                <Section title="Haftungsausschluss">
                    <Typography paragraph>
                        Alle auf dieser Internetseite bereitgestellten Informationen haben wir nach bestem Wissen und Gewissen erarbeitet und geprüft. 
                        Eine Gewähr für die jederzeitige Aktualität, Richtigkeit, Vollständigkeit und Verfügbarkeit der bereit gestellten Informationen 
                        können wir allerdings nicht übernehmen. Ein Vertragsverhältnis mit den Nutzern des Internetangebots kommt nicht zustande.
                    </Typography>
                    <Typography paragraph>
                        Wir haften nicht für Schäden, die durch die Nutzung dieses Internetangebots entstehen. Dieser Haftungsausschluss gilt nicht, 
                        soweit die Vorschriften des § 839 BGB (Haftung bei Amtspflichtverletzung) einschlägig sind. Für etwaige Schäden, die beim 
                        Aufrufen oder Herunterladen von Daten durch Schadsoftware oder der Installation oder Nutzung von Software verursacht werden, 
                        wird nicht gehaftet.
                    </Typography>
                    <Typography paragraph>
                        Der Haftungsausschluss gilt nicht für Informationen, die in den Anwendungsbereich der Europäischen Dienstleistungsrichtlinie 
                        (Richtlinie 2006/123/EG . DLRL) fallen. Für diese Informationen wird die Richtigkeit und Aktualität gewährleistet.
                    </Typography>
                </Section>

                <Section title="Links">
                    <Typography paragraph>
                        Von unseren eigenen Inhalten sind Querverweise ("Links") auf die Webseiten anderer Anbieter zu unterscheiden. 
                        Durch diese Links ermöglichen wir lediglich den Zugang zur Nutzung fremder Inhalte nach § 8 Telemediengesetz. 
                        Bei der erstmaligen Verknüpfung mit diesen Internetangeboten haben wir diese fremden Inhalte daraufhin überprüft, 
                        ob durch sie eine mögliche zivilrechtliche oder strafrechtliche Verantwortlichkeit ausgelöst wird. Wir können diese 
                        fremden Inhalte aber nicht ständig auf Veränderungen überprüfen und daher auch keine Verantwortung dafür übernehmen. 
                        Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung 
                        von Informationen Dritter entstehen, haftet allein der jeweilige Anbieter der Seite.
                    </Typography>
                </Section>

                <Section title="Datenschutzerklärung">
                    <Typography variant="h6" gutterBottom>
                        Protokollierung
                    </Typography>
                    <Typography paragraph>
                        Wenn Sie diese oder andere Internetseiten aufrufen, übermitteln Sie über Ihren Internetbrowser Daten an unseren Webserver. 
                        Die folgenden Daten werden während einer laufenden Verbindung zur Kommunikation zwischen Ihrem Internetbrowser und unserem Webserver aufgezeichnet:
                    </Typography>
                    <Typography component="div" sx={{ pl: 2, mb: 2 }}>
                        • Datum und Uhrzeit der Anforderung<br />
                        • Name der angeforderten Datei<br />
                        • Seite, von der aus die Datei angefordert wurde<br />
                        • Zugriffsstatus (Datei übertragen, Datei nicht gefunden, etc.)<br />
                        • verwendete Webbrowser und verwendetes Betriebssystem<br />
                        • vollständige IP-Adresse des anfordernden Rechners<br />
                        • übertragene Datenmenge
                    </Typography>

                    <Typography paragraph>
                        Aus Gründen der technischen Sicherheit, insbesondere zur Abwehr von Angriffsversuchen auf unseren Webserver, 
                        werden diese Daten von uns gespeichert. Nach spätestens sieben Tagen werden die Daten durch Verkürzung der 
                        IP-Adresse auf Domain-Ebene anonymisiert, so dass es nicht mehr möglich ist, einen Bezug auf einzelne Nutzer 
                        herzustellen. Die Daten werden ausschließlich zu diesem Zweck und in anonymisierter Form zu statistischen 
                        Zwecken verarbeitet; ein Abgleich mit anderen Datenbeständen oder eine Weitergabe an Dritte, auch in Auszügen, 
                        findet nicht statt.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Cookies
                    </Typography>
                    <Typography paragraph>
                        Beim Zugriff auf dieses Internetangebot werden von uns Cookies (kleine Dateien) auf Ihrer Festplatte gespeichert, 
                        die für die Dauer Ihres Besuches auf der Internetseite gültig sind. Wir verwenden diese ausschließlich dazu, 
                        Sie während Ihres Besuchs unserer Internetseite zu identifizieren. Die meisten Browser sind so eingestellt, 
                        dass sie die Verwendung von Cookies akzeptieren, diese Funktion kann aber durch die Einstellung des Internetbrowsers 
                        von Ihnen für die laufende Sitzung oder dauerhaft abgeschaltet werden. Nach Ende Ihres Besuches werden diese 
                        Cookies automatisch wieder von Ihrer Festplatte gelöscht. Die Benutzeranmeldung für das Extranet ist nur nutzbar, 
                        wenn Sie uns die Möglichkeit zur Speicherung von Cookies geben.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Aktive Komponenten
                    </Typography>
                    <Typography paragraph>
                        Im Informationsangebot werden Javascripts verwendet. Diese Funktion kann durch die Einstellung Ihres Internetbrowsers 
                        von Ihnen abgeschaltet werden.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Auswertung des Nutzerverhaltens
                    </Typography>
                    <Typography paragraph>
                        Für die statistische Auswertung von Besucherzugriffen verwenden wir die Open-Source-Software Matomo. Die mit dieser 
                        Software erfassten Daten werden in anonymisierter Form dazu verwendet, um die Nutzung der Website zu analysieren und 
                        sie zu verbessern. Ihre IP-Adresse wird bei diesem Vorgang umgehend anonymisiert, so dass Sie als Nutzer für uns 
                        anonym bleiben. Durch die Nutzung der Website erklären Sie sich mit der Verarbeitung der erhobenen Daten durch 
                        Matomo in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.
                    </Typography>
                    <Typography paragraph>
                        Sie können die Datenerfassung durch Matomo verhindern, indem Sie in Ihrem Internetbrowser die Funktion "Do Not Track" 
                        aktivieren. Bei den meisten Browsern finden Sie diese Funktion unter "Einstellungen" {String.fromCharCode(8594)} "Datenschutz".
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Elektronische Post (E-Mail)
                    </Typography>
                    <Typography paragraph>
                        Informationen, die Sie unverschlüsselt per Elektronische Post (E-Mail) an uns bzw. die Gerichte senden, 
                        können möglicherweise auf dem Übertragungsweg von Dritten gelesen werden. Wir können in der Regel auch 
                        Ihre Identität nicht überprüfen und wissen nicht, wer sich hinter einer E-Mail-Adresse verbirgt. Eine 
                        rechtssichere Kommunikation durch einfache E-Mail ist daher nicht gewährleistet.
                    </Typography>
                    <Typography paragraph sx={{ fontWeight: 'bold' }}>
                        E-Mails dürfen deshalb nicht in Rechtsangelegenheiten benutzt werden!
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Elektronischer Rechtsverkehr
                    </Typography>
                    <Typography paragraph>
                        Manche Gerichte nutzen zur sicheren Kommunikation das Elektronische Gerichts- und Verwaltungsportal (EGVP). 
                        Auf diesem Weg können Sie den Gerichten verschlüsselte und signierte Nachrichten zu kommen lassen. Die Informationen, 
                        welche Gerichte an das EGVP angeschlossen sind, erhalten Sie auf den jeweiligen Gerichtsseiten. Wie sie selbst das 
                        Elektronische Gerichts- und Verwaltungsportal nutzen können, erfahren Sie unter:
                    </Typography>
                    <Typography component="div" sx={{ pl: 2 }}>
                        <Link href="http://www.egvp.de/" target="_blank" rel="noopener noreferrer">
                            http://www.egvp.de/
                        </Link>
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Ansprechpartner und weitere Informationen
                    </Typography>
                    <Typography paragraph>
                        Wenn Sie noch Fragen zum Datenschutz im Zusammenhang mit dieser Internetseite haben, können Sie sich an den 
                        Datenschutzbeauftragten des Bayer. Landessozialgerichts (Email: <Link href="mailto:datenschutz@lsg.bayern.de">datenschutz@lsg.bayern.de</Link>) wenden. Der 
                        Datenschutzbeauftragte des Bayerischen Landessozialgerichts hat diese Internetseite im Hinblick auf die 
                        Einhaltung datenschutzrechtlicher Vorschriften überprüft und freigegeben. Weitere Informationen zum Thema 
                        Datenschutz finden Sie auch auf den Internetseiten des Bayerischen Landesbeauftragten für den Datenschutz:{' '}
                        <Link href="http://www.datenschutz-bayern.de" target="_blank" rel="noopener noreferrer">
                            http://www.datenschutz-bayern.de
                        </Link>
                    </Typography>
                </Section>

                <Section title="Technische Umsetzung & Betrieb">
                    <Typography>
                        Die technische Umsetzung und Betrieb dieser Webseite wird realisiert durch die STARK IT-Security GmbH.{' '}
                        <Link href="https://www.stark-its.de/" target="_blank" rel="noopener noreferrer">
                            https://www.stark-its.de/
                        </Link>
                    </Typography>
                </Section>
            </Paper>
        </Container>
    );
};

export default Impressum; 